import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";

import { type DocumentStatusCardVariant } from "../components/StatusCard";

export const workerRequirementStatusToDocumentCardStatus: Record<
  WorkerRequirementStatus,
  DocumentStatusCardVariant | undefined
> = {
  [WorkerRequirementStatus.APPROVED]: "approved",
  [WorkerRequirementStatus.IN_REVIEW]: "in_review",
  [WorkerRequirementStatus.REJECTED]: "rejected",
  [WorkerRequirementStatus.EXPIRED]: "expired",
  [WorkerRequirementStatus.EXPIRING]: "expiring_soon",
  [WorkerRequirementStatus.MISSING]: undefined,
};
